
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

export type UserRole = "admin" | "editor" | "viewer";

export interface TeamUser {
  id: string;
  name: string;
  email: string;
  role: UserRole;
}

interface UserListItemProps {
  user: TeamUser;
  onEditUser: (user: TeamUser) => void;
  onDeleteUser?: (user: TeamUser) => void;
}

const UserListItem = ({ user, onEditUser, onDeleteUser }: UserListItemProps) => {
  const getRoleBadgeStyle = (role: UserRole) => {
    switch(role) {
      case "admin":
        return "bg-brand-teal";
      case "editor":
        return "bg-blue-500";
      case "viewer":
      default:
        return "bg-gray-500";
    }
  };

  return (
    <div className="p-4 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <Avatar>
          <AvatarFallback className={user.role === 'admin' ? "bg-brand-teal/10 text-brand-teal" : "bg-green-100 text-green-600"}>
            {user.name.split(' ').map(name => name[0]).join('').toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div>
          <p className="font-medium">{user.name}</p>
          <p className="text-sm text-gray-500">{user.email}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Badge className={getRoleBadgeStyle(user.role)}>
          {user.role === 'admin' ? 'Administrador' : 
           user.role === 'editor' ? 'Editor' : 'Visualizador'}
        </Badge>
        <Button 
          variant="ghost" 
          size="sm"
          onClick={() => onEditUser(user)}
        >
          Editar
        </Button>
        {onDeleteUser && (
          <Button 
            variant="ghost" 
            size="sm"
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
            onClick={() => onDeleteUser(user)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default UserListItem;
